import {
  TOGGLE_COURSES,
  TOGGLE_RESOURCES,
  TOGGLE_PROFILE,
  TOGGLE_ACHIEVEMENTS,
} from '../constants';

export function toggleCourses() {
  return {
    type: TOGGLE_COURSES,
  };
}

export function toggleResources() {
  return {
    type: TOGGLE_RESOURCES,
  };
}

export function toggleProfile() {
  return {
    type: TOGGLE_PROFILE,
  };
}

export function toggleAchievements() {
  return {
    type: TOGGLE_ACHIEVEMENTS,
  };
}
